import { datadogLogs } from '@datadog/browser-logs';

const getIpAddr = async () => {
  let ip: string = '';
  const cachedIp = localStorage.getItem('ipAddr');
  try {
    if (!cachedIp) {
      const response = await fetch('https://api.ipify.org/');
      ip = await response.text();
      if (ip) {
        localStorage.setItem('ipAddr', ip);
      }
    }
  } catch (e) {
    console.warn(e);
    datadogLogs.logger.warn(
      'GET api.ipify.org failed',
      { url: window.location.href },
      e
    );
  }
  return ip || cachedIp;
};

export default getIpAddr;
